import { useState, useEffect } from 'react';
import { send } from 'emailjs-com';

import './ContactForm.css';

function ContactForm() {
  const [formFade, setFormFade] = useState({
    fade: 'fade-out',
    position: 'bottom',
  });
  const [status, setStatus] = useState('');
  const [data, setData] = useState({ name: '', email: '', message: '' });

  useEffect(() => {
    const timeout = setInterval(() => {
      if (formFade.fade === 'fade-out') {
        setFormFade({
          fade: 'fade-in',
          position: 'center',
        });
      }
    }, 200);
    return () => clearInterval(timeout);
  }, [formFade]);
  useEffect(() => {
    setTimeout(() => {
      setStatus('');
    }, 5000);
  }, [status]);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    for (const key in data) {
      if (data[key].length === 0) {
        return;
      }
    }

    send(
      'service_5j7fvul',
      'template_0xbsqca',
      data,
      'user_EBmWuvrtmw0WyMXJv9AlF'
    )
      .then((response) => {
        setStatus('success');
        console.log('SUCCESS!', response.status, response.text);
      })
      .catch((err) => {
        setStatus('failed');
        console.log('FAILED...', err);
      });

    setData({ name: '', email: '', message: '' });
  };

  return (
    <>
      <form
        onSubmit={handleSubmit}
        className={`${formFade.fade} ${formFade.position}`}
      >
        <div className="form__group">
          <label htmlFor="name">Nombre</label>
          <input
            type="text"
            id="name"
            name="name"
            value={data.name}
            onChange={handleChange}
          ></input>
        </div>
        <div className="form__group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={data.email}
            onChange={handleChange}
          ></input>
        </div>
        <div className="form__group bottom-group">
          <label htmlFor="message">Mensaje</label>
          <textarea
            id="message"
            name="message"
            rows="6"
            value={data.message}
            onChange={handleChange}
          ></textarea>
          <button type="submit">Enviar</button>
        </div>
      </form>
      {status !== '' ? (
        status === 'success' ? (
          <p className="status-message success-message">
            Mensaje enviado con éxito. Gracias!
          </p>
        ) : (
          <p className="status-message error-message">
            Hubo un error al envíar el mensaje. Contactame por mis redes!
          </p>
        )
      ) : (
        ''
      )}
    </>
  );
}

export default ContactForm;
